import React from 'react';
import Grid from 'e100-react-components/lib/components/Grid';
import MapTypeControl from './MapTypeControl';

import { Props as FooterProps } from '../';
import { FooterElements } from 'components/Map/types/footerElements';
import { StationsDisplayButton } from './StationsDisplayButton/StationsDisplayButton';

import { useStyles } from './styles';

const LeftColumn = ({
  leftColumnElements,
  showStationsDisplayButton
}: Props) => {
  const classes = useStyles();
  return (
    <Grid item>
      <Grid container alignItems="center"> 
        <Grid item classes={{ root: classes.mapTypeControlContainer }}>
          <MapTypeControl />
        </Grid>
        {
          showStationsDisplayButton && (
            <Grid item classes={{ root: classes.stationDisplayButtonContainer }}>
              <StationsDisplayButton />
            </Grid>
          )
        }
        <Grid>
          {leftColumnElements}
        </Grid>
      </Grid>
    </Grid>
  );
};

export interface Props extends Pick<FooterProps, 'showStationsDisplayButton'> {
  leftColumnElements: FooterElements['leftColumn'];
}

export default LeftColumn;
